import { useRef } from 'react'
import { Header } from '../components/Header.jsx'
import { Tile } from '../components/Tile.jsx'
import { getViewData } from './MenuView'
import techData from '../data/tech.json'

export const TechView = () => {
  const viewData = getViewData('tech')
  const toastRef = useRef()

  return (
    <>
      <Header
        title={viewData.title}
        icon={viewData.icon}
        description={viewData.description}
      />
      <div>
        <div className='tech_container'>
          {techData.data.map((tech) => (
            <Tile
              name={tech.name}
              icon={tech.source}
              ref={toastRef}
              key={tech.name}
            />
          ))}
        </div>
        {/* <div className='tech_container_alt'>
          <h3>Misc:</h3>
          <span>{techData.misc.join('  |  ')}</span>
        </div> */}
      </div>
      <span ref={toastRef} className='toast' />
    </>
  )
}
